import { useAssetParams } from '../../../../hooks/useAssetParams'
import { safeDecodeFromUrl } from '../../../../utils'
import { VisualizeTree } from '../../Insights/ML/VisualizeTree/VisualizeTree'
import styles from './TreeAsset.module.scss'

export const TreeAsset = () => {
    const { params } = useAssetParams()

    return (
        params?.object && (
            <div id={'chat-screenshot-container'} className={styles.container}>
                <VisualizeTree graph={JSON.parse(safeDecodeFromUrl(params.object))} screenshot />
            </div>
        )
    )
}
